import React from "react";

const SVG = ({ width = "100%", className = "", viewBox = "0 0 14 7", color = "#916DA8" }) => (
  <svg
    width={width}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h14v6H0z" />
      <path
        d="M12.699 1.393a.875.875 0 0 1-.248 1.212L7.4 5.94a.875.875 0 0 1-.964 0L1.393 2.606a.875.875 0 1 1 .965-1.46l4.56 3.015 4.568-3.016a.875.875 0 0 1 1.212.248z"
        fill={color}
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default SVG;
